/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: ylq
 * @Last Modified time: 2023-09-19 17:54:50
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const CLIENT = {
  path: '/client',
  name: 'client',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'client-list' },
  meta: {
    title: '客户',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'customer',
    order: 3
  },
  children: [
    {
      path: 'index',
      name: 'client-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'client-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'customer:view',
        title: '客户管理'
      },
      children: [
        {
          path: '',
          name: 'client-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 2 },
          meta: {
            requiresAuth: true,
            roles: 'customer:view',
            title: '客户管理'
          }
        },
        {
          path: ':id/collaborators',
          name: 'client-index-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 2 },
          meta: {
            requiresAuth: true,
            title: '客户管理详情',
            roles: 'customer:view'
          }
        },
        {
          path: ':id',
          name: 'client-index-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 2 },
          meta: {
            requiresAuth: true,
            title: '客户管理详情',
            roles: 'customer:view'
          }
        }
      ]
    }
  ]
};

export default CLIENT;
